import {errorHandler} from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Query, Req } from '@nestjs/common';
import { MandalService } from './mandal.service';
import { getdistrictDTO, MandalDTO, MandalStatusDTO } from './dto/mandal.dto';
import { MandalIdRequest, MandalNameRequest } from './dto/mandalname.request';
import { MandalResponseModel, } from './dto/mandal-response.model';
import { AllMandalResponseModel } from './dto/all-mandal-response.model';
import { MandalStatusWiseResponseModel } from './dto/mandal-status-response.model';
import { ApiQuery, ApiTags } from '@nestjs/swagger';
import { request } from 'https';


@ApiTags('Mandal')
@Controller('mandal')
export class MandalController {
    constructor(
        private mandalService: MandalService
    ){}

    @Post('/createMandal')
    @ApiQuery({name:'apiVersion'})
    async createMandal(@Query() queryParams,@Body() mandalDto:MandalDTO,isUpdate:boolean=false,@Req() request:Request):Promise<MandalResponseModel>{
        try{
            return await this.mandalService.createMandal(queryParams,mandalDto,false,request);
        } catch (error) {
            return errorHandler(MandalResponseModel,error);
        }
    }

    @Post('/updateMandal')
    @ApiQuery({name:'apiVersion'})
    async updateMandal(@Query() queryParams, @Body() mandalDto: MandalDTO, @Req() request:Request):Promise<MandalResponseModel>{
        try {
           return await this.mandalService.createMandal(queryParams,mandalDto,true,request);
        } catch (error) {
           return errorHandler(MandalResponseModel,error);
        }
    }

    @Post('/getAllMandals')
    @ApiQuery({name:'apiVersion'})
    async getAllMandals(@Query() queryParams, @Req() request: Request): Promise<AllMandalResponseModel> {
        try {
        return await this.mandalService.getAllMandals(queryParams, request);
        } catch (error) {
        return errorHandler(AllMandalResponseModel, error);
        }
    }

    @Post('/getMandalByMandalName')
    @ApiQuery({name:'apiVersion'})
    async getMandalByMandalName (@Query() queryParams, @Body() MandalNameRequest: MandalNameRequest, @Req() request: Request): Promise<MandalResponseModel>{
        try{
            return await this.mandalService.getMandalByMandalName(queryParams,MandalNameRequest.mandalName,request);
        } catch(error){
            return errorHandler(MandalResponseModel,error);
        }
    }

    @Post('/getMandalByMandalId')
    @ApiQuery({name:'apiVersion'})
    async getMandalByMandalId(@Query() queryParams, @Body() MandalIdRequest: MandalIdRequest, @Req() request: Request): Promise<MandalResponseModel>{
        try{
            return await this.mandalService.getMandalByMandalId(queryParams,MandalIdRequest.Id,request);
        } catch (error) {
            return errorHandler(MandalResponseModel, error);
        }
    }

    @Post('/getAllActiveMandal')
    @ApiQuery({name:'apiVersion'})
    async getAllActiveMandal(@Query() queryParams, @Req() request: Request): Promise<AllMandalResponseModel>{
        try{
            return await this.mandalService.getAllActiveMandal(queryParams,request);
        }catch (error){
            return errorHandler (AllMandalResponseModel, error);
        }
    }

    @Post('/getActiveMandalCount')
    @ApiQuery({name:'apiVersion'})
    async getActiveMandalCount(@Query() queryParams, @Req() request: Request): Promise<MandalStatusWiseResponseModel>{
        try {
            return await this.mandalService.getActiveMandalCount(queryParams,request);
        } catch (error) {
            return errorHandler(MandalStatusWiseResponseModel, error);
        }
    }

    @Post('/UpdateMandalStatus')
    @ApiQuery({name:'apiVersion'})
    async UpdateMandalStatus(@Query() queryParams,@Body() mandalStatusDto: MandalStatusDTO, @Req() request: Request): Promise<MandalResponseModel>{
        try {
            return await this.mandalService.UpdateMandalStatus(queryParams,mandalStatusDto,request);
        } catch (error) {
            return errorHandler(MandalResponseModel,error);
        }
    }

    @Post('/districtid')
    @ApiQuery({name:'apiVersion'})
    async getmandalbydistrictid(@Query() queryParams,@Body() getdistrictDTO:getdistrictDTO,request: Request): Promise<AllMandalResponseModel> {
        try {
            return await this.mandalService.getmandalbydistrictid(queryParams,getdistrictDTO,request);
        } catch (error) {
            return errorHandler(AllMandalResponseModel, error);
        }
    }
    
}
